import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FeeScheduleView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for handling fee schedule row selection and navigation
 */
export function useFeeScheduleNavigation(company: string | undefined) {
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    (args: { data: FeeScheduleView }) => {
      const selectedFeeSchedule = args.data;
      if (selectedFeeSchedule && company) {
        const url = `/feeschedules/edit?company=${encodeURIComponent(company)}&feeScheduleId=${encodeURIComponent(selectedFeeSchedule.id)}`;
        navigate(url);
      }
    },
    [company, navigate]
  );

  return {
    handleRowClick,
  };
}
